// @ts-nocheck
import { plugin } from './plugin';
import * as Plugin_0 from '../../app.jsx';
import * as Plugin_1 from '../plugin-dva/runtime.tsx';

  plugin.register({
    apply: Plugin_0,
    path: '../../app.jsx',
  });
  plugin.register({
    apply: Plugin_1,
    path: '../plugin-dva/runtime.tsx',
  });

export const __mfsu = 1;
